module.exports = __webpack_public_path__ + "static/media/vyroba-svice.0f8f3129.jpg";